export default (state, action) => {
    const { type, payload } = action
    switch (type) {
        case 'SET_LOADED':
            return {
                ...state,
                loaded: true,
            }
        case 'SET_USER':
            return {
                ...state,
                user: payload,
            }
        case 'SET_COMPANIES':
            return {
                ...state,
                companies: payload,
            }
        case 'SET_PARTNERSHIPS':
            return {
                ...state,
                partnerships: payload,
            }
        case 'SET_SELECTED':
            return {
                ...state,
                selected: payload,
            }
        case 'TOGGLE_SIDEBAR_STATE':
            return {
                ...state,
                sidebarOpen: payload ? payload : !state.sidebarOpen,
            }
        default:
            throw new Error(`Unhandled action type: ${type}`)
    }
}
